<div fxFlex="column" class="grade-dialog">
  
  <div class="dialog-header">
    {{ title }}
  </div>
  <div class="grade-container" fxLayout="column">
    <form [formGroup]="registerForm" class="account-form"
    (keydown)="EnterSubmit($event, registerForm)">
      <div
        fxLayout="row"
        fxLayoutAlign="space-between center"
        class="row-padded"
      >
        <div fxFlex="20" class="form-key">Student FirstName :</div>
        <div fxFlex="75">
          <mat-form-field class="full-width">
            <input
              type="text" 
              matInput
              formControlName="StudentFirstName"
              name="StudentFirstName"
            />
            <mat-error
              *ngIf="
                isValidInput('StudentFirstName') &&
                registerForm.controls['StudentFirstName'].errors.required
              "
              class="mat-error"
            >
              Student FirstName is required.
            </mat-error>
          </mat-form-field>
        </div>
      </div>
      <div
        fxLayout="row"
        fxLayoutAlign="space-between center"
        class="row-padded"
      >
        <div fxFlex="20" class="form-key">Student LastName :</div>
        <div fxFlex="75">
          <mat-form-field class="full-width">
            <input
              type="text"
              matInput
              formControlName="StudentLastName"
              name="StudentLastName"
            />
            <mat-error
              *ngIf="
                isValidInput('StudentLastName') &&
                registerForm.controls['StudentLastName'].errors.required
              "
              class="mat-error"
            >
              Student LastName is required.
            </mat-error>
          </mat-form-field>
        </div>
      </div>
      <div
        fxLayout="row"
        fxLayoutAlign="space-between center"
        class="row-padded"
      >
        <div fxFlex="20" class="form-key">Student Email :</div>
        <div fxFlex="75">
          <mat-form-field class="full-width">
            <input
              type="text"
              matInput
              formControlName="StudentEmail"
              name="StudentEmail"
              pattern="[a-zA-Z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,8}$"
              (keyup)="search()"
            />
            <mat-error
              *ngIf="
                isValidInput('StudentEmail') &&
                registerForm.controls['StudentEmail'].errors.required
              "
              class="mat-error"
            >
              Student Email is required.
            </mat-error>
            <mat-error
              *ngIf="
                isValidInput('StudentEmail') &&
                registerForm.controls['StudentEmail'].errors.pattern
              "
              class="mat-error"
            >
              Must be a valid email format.
            </mat-error>
          </mat-form-field>
        </div>
      </div>
      <div
        fxLayout="row"
        fxLayoutAlign="space-between center"
        class="row-padded"
      >
        <div fxFlex="20" class="form-key">Default Password :</div>
        <div fxFlex="75">
          <mat-form-field class="full-width">
            <input
              [type]="passwordHide ? 'password' : 'text'"
              matInput
              autocomplete="new-password"
              formControlName="Password"
              name="Password"
              minlength="8"
            />
            <mat-icon matSuffix (click)="passwordHide = !passwordHide">{{
              passwordHide ? "visibility" : "visibility_off"
            }}</mat-icon>
            <mat-error
              *ngIf="
                isValidInput('Password') &&
                registerForm.controls['Password'].errors.minlength
              "
              class="mat-error"
            >
              Minimum 8 characters required
            </mat-error>
          </mat-form-field>
        </div>
      </div>

      <div
        class="button-container"
        fxLayout="row"
        fxLayoutAlign="space-around center"
      >
        <div>
          <button
            class="secondary-button button"
            type="button"
            (click)="onCancel()"
          >
            Cancel
          </button>
        </div>
        <div>
          <button
            class="primary-button button"
            type="button"
            (click)="onSubmit(registerForm)"
          >
            Submit
          </button>
        </div>
      </div>
    </form>
  </div>

</div>

<div *ngIf="registerNewStudentWait" class="spinner-wrapper">
  <mat-spinner [diameter]="50" mode="indeterminate"></mat-spinner>
</div>
